import { appSettings } from '@/shared/consts/appSettings'
import * as scheduleLeadWebhook from '@rededor/schedule-lead-webhook'

export const initScheduleLeadWebhook = () => {
  if (appSettings.scheduleLeadWebhook.active) {
    scheduleLeadWebhook.init({
      utmSource: appSettings.scheduleLeadWebhook.utmSource,
      gaCookieName: appSettings.scheduleLeadWebhook.gaCookieName,
      webhookToken: appSettings.scheduleLeadWebhook.token
    })
  }
}
